module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.bd807bc1.eot";